<template>
  <div class="cookie-consent">
    <b-modal v-model="is_cookie_consent_modal_active" :can-cancel="false" :aria-modal="true">
      <div class="card">
        <div class="card-content">
          <div class="media">
            <div class="media-content">
              <span class="title is-4">{{ $t('cookie-consent.we_use_cookies') }}</span>
            </div>
          </div>
          <div class="content">
            <p>
              {{ $t('cookie-consent.general_cookie_info') }}
              <a href="javascript:void(0)" @click="openCookiePreferenceModal(); closeCookieConsentModal();">{{ $t('cookie-consent.read_more') }}</a>
            </p>
            <p>
              {{ $t('cookie-consent.you_can_choose_if_you_want_cookies') }}
            </p>
            <hr>
            <button class="button is-primary" @click="acceptAll()">
              {{ $t('cookie-consent.accept_all') }}
            </button>
            <button class="button is-light" @click="acceptOnlyNecessary();">
              {{ $t('cookie-consent.accept_only_necessary') }}
            </button>
            <button class="button is-light" @click="openCookiePreferenceModal(); closeCookieConsentModal();">
              {{ $t('cookie-consent.change_preferences') }}
            </button>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal v-model="is_cookie_preference_modal_active" :can-cancel="false" :aria-modal="true">
      <div class="card">
        <div class="card-content" style="height: 500px; overflow: auto">
          <div class="media">
            <div class="media-content">
              <span class="title is-4">{{ $t('cookie-consent.cookie_policy') }}</span>
            </div>
          </div>
          <div class="content">
            <h4>{{ $t('cookie-consent.what_are_cookies') }}</h4>
            {{ $t('cookie-consent.general_cookie_info') }}
            {{ $t('cookie-consent.read_more_general_cookie_info') }}
            <br>
            <br>
            {{ $t('cookie-consent.cookies_will_only_be_placed') }}
            <br>
            <br>
            {{ $t('cookie-consent.legal_basis_for_the_use_of_cookies') }}
            <br>
            <br>
            <h4>{{ $t('cookie-consent.cookies_purposes') }}</h4>
            <div class="collapse card">
              <div class="card-header" role="button">
                <div class="card-header-title" style="display: block;">
                  {{ $t('cookie-consent.necessary_cookies') }}
                  <br>
                  <span class="show_details has-text-primary" @click="show_necessary_cookies_details = !show_necessary_cookies_details">
                    <span v-if="!show_necessary_cookies_details">
                      {{ $t('cookie-consent.show_details') }} <i class="fa fa-angle-down"></i>
                    </span>
                    <span v-if="show_necessary_cookies_details">
                      {{ $t('cookie-consent.hide_details') }} <i class="fa fa-angle-up"></i>
                    </span>
                  </span>
                </div>
                <a class="card-header-icon">
                  <b-switch v-model="necessary_cookies_consent" disabled type="is-success">
                    {{ $t('cookie-consent.always_enabled') }}
                  </b-switch>
                </a>
              </div>
            </div>
            <b-collapse v-model="show_necessary_cookies_details" class="card">
              <div class="card-content">
                <div class="content">
                  {{ $t('cookie-consent.necessary_cookies_description') }}
                  <br><br>
                  <table class="table is-bordered is-narrow is-hoverable is-fullwidth">
                    <thead>
                      <tr>
                        <th style="width: 25%">{{ $t('cookie-consent.cookies_table.cookies') }}</th>
                        <th style="width: 12%">{{ $t('cookie-consent.cookies_table.type') }}</th>
                        <th style="width: 20%">{{ $t('cookie-consent.cookies_table.duration') }}</th>
                        <th>{{ $t('cookie-consent.cookies_table.description') }} </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td style="word-break: break-all;">147trainingcom_session</td>
                        <td>{{ $t('cookie-consent.cookies_table.first_party') }}</td>
                        <td>24 {{ $t('cookie-consent.cookies_table.hours') }}</td>
                        <td>{{ $t('cookie-consent.cookies_table.147training_com_session_description') }}</td>
                      </tr>
                      <tr>
                        <td style="word-break: break-all;">necessary_cookies_consent</td>
                        <td>{{ $t('cookie-consent.cookies_table.first_party') }}</td>
                        <td>1 {{ $t('cookie-consent.cookies_table.year') }}</td>
                        <td>{{ $t('cookie-consent.cookies_table.necessary_cookie_consent_status_description') }}</td>
                      </tr>
                      <tr>
                        <td style="word-break: break-all;">statistics_cookies_consent</td>
                        <td>{{ $t('cookie-consent.cookies_table.first_party') }}</td>
                        <td>1 {{ $t('cookie-consent.cookies_table.year') }}</td>
                        <td>{{ $t('cookie-consent.cookies_table.statistics_cookie_consent_status_description') }}</td>
                      </tr>
                      <tr>
                        <td style="word-break: break-all;">social_cookies_consent</td>
                        <td>{{ $t('cookie-consent.cookies_table.first_party') }}</td>
                        <td>1 {{ $t('cookie-consent.cookies_table.year') }}</td>
                        <td>{{ $t('cookie-consent.cookies_table.social_cookie_consent_status_description') }}</td>
                      </tr>
                      <tr>
                        <td style="word-break: break-all;">XSRF-TOKEN</td>
                        <td>{{ $t('cookie-consent.cookies_table.first_party') }}</td>
                        <td>{{ $t('cookie-consent.cookies_table.xsrf_token_duration') }}</td>
                        <td>{{ $t('cookie-consent.cookies_table.xsrf_token_description') }}</td>
                      </tr>
                      <tr>
                        <td style="word-break: break-all;">Remember_web</td>
                        <td>{{ $t('cookie-consent.cookies_table.first_party') }}</td>
                        <td>3 {{ $t('cookie-consent.cookies_table.years') }}</td>
                        <td>{{ $t('cookie-consent.cookies_table.remember_me_description') }}</td>
                      </tr>
                      <tr>
                        <td style="word-break: break-all;">
                          _ga<br>
                          _gid<br>
                          has_logged_in<br>
                          has_uploaded<br>
                          is_logged_in<br>
                          player<br>
                          vimeo<br>
                          vuid
                        </td>
                        <td>{{ $t('cookie-consent.cookies_table.third_party') }}</td>
                        <td>{{ $t('cookie-consent.cookies_table.vimeo_cookie_duration') }}</td>
                        <td>{{ $t('cookie-consent.cookies_table.vimeo_cookie_description') }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </b-collapse>

            <div class="collapse card">
              <div class="card-header" role="button">
                <div class="card-header-title" style="display: block;">
                  {{ $t('cookie-consent.statistics_cookies') }}
                  <br>
                  <span class="show_details has-text-primary" @click="show_statistics_cookies_details = !show_statistics_cookies_details">
                    <span v-if="!show_statistics_cookies_details">
                      {{ $t('cookie-consent.show_details') }} <i class="fa fa-angle-down"></i>
                    </span>
                    <span v-if="show_statistics_cookies_details">
                      {{ $t('cookie-consent.hide_details') }} <i class="fa fa-angle-up"></i>
                    </span>
                  </span>
                </div>
                <a class="card-header-icon">
                  <b-switch v-model="statistics_cookies_consent" type="is-success">
                    <span v-if="statistics_cookies_consent">{{ $t('cookie-consent.enabled') }}</span>
                    <span v-else>{{ $t('cookie-consent.disabled') }}</span>
                  </b-switch>
                </a>
              </div>
            </div>
            <b-collapse v-model="show_statistics_cookies_details" class="card">
              <div class="card-content">
                <div class="content">
                  {{ $t('cookie-consent.statistics_cookies_description') }}
                  <br><br>
                  <table class="table is-bordered is-narrow is-hoverable is-fullwidth">
                    <thead>
                      <tr>
                        <th style="width: 25%">{{ $t('cookie-consent.cookies_table.cookies') }}</th>
                        <th style="width: 12%" class="is-2">{{ $t('cookie-consent.cookies_table.type') }}</th>
                        <th style="width: 20%" class="is-2">{{ $t('cookie-consent.cookies_table.duration') }}</th>
                        <th>{{ $t('cookie-consent.cookies_table.description') }} </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>_ga</td>
                        <td>{{ $t('cookie-consent.cookies_table.third_party') }}</td>
                        <td>24 {{ $t('cookie-consent.cookies_table.hours') }}</td>
                        <td>{{ $t('cookie-consent.cookies_table.ga_description') }}</td>
                      </tr>
                      <tr>
                        <td style="word-break: break-all;">_gat_gtag_UA_150117729_1</td>
                        <td>{{ $t('cookie-consent.cookies_table.third_party') }}</td>
                        <td>{{ $t('cookie-consent.cookies_table.session') }}</td>
                        <td>{{ $t('cookie-consent.cookies_table.gat_description') }}</td>
                      </tr>
                      <tr>
                        <td>_gid</td>
                        <td>{{ $t('cookie-consent.cookies_table.third_party') }}</td>
                        <td>{{ $t('cookie-consent.cookies_table.session') }}</td>
                        <td>{{ $t('cookie-consent.cookies_table.gid_description') }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </b-collapse>

            <div class="collapse card">
              <div class="card-header" role="button">
                <div class="card-header-title" style="display: block;">
                  {{ $t('cookie-consent.social_cookies') }}
                  <br>
                  <span class="show_details has-text-primary" @click="show_social_cookies_details = !show_social_cookies_details">
                    <span v-if="!show_social_cookies_details">
                      {{ $t('cookie-consent.show_details') }} <i class="fa fa-angle-down"></i>
                    </span>
                    <span v-if="show_social_cookies_details">
                      {{ $t('cookie-consent.hide_details') }} <i class="fa fa-angle-up"></i>
                    </span>
                  </span>
                </div>
                <a class="card-header-icon" type="is-success">
                  <b-switch v-model="social_cookies_consent" type="is-success">
                    <span v-if="social_cookies_consent">{{ $t('cookie-consent.enabled') }}</span>
                    <span v-else>{{ $t('cookie-consent.disabled') }}</span>
                  </b-switch>
                </a>
              </div>
            </div>
            <b-collapse v-model="show_social_cookies_details" class="card">
              <div class="card-content">
                <div class="content">
                  {{ $t('cookie-consent.social_cookies_description') }}
                  <br><br>
                  <table class="table is-bordered is-narrow is-hoverable is-fullwidth">
                    <thead>
                    <tr>
                      <th style="width: 25%">{{ $t('cookie-consent.cookies_table.cookies') }}</th>
                      <th style="width: 12%" class="is-2">{{ $t('cookie-consent.cookies_table.type') }}</th>
                      <th style="width: 20%" class="is-2">{{ $t('cookie-consent.cookies_table.duration') }}</th>
                      <th>{{ $t('cookie-consent.cookies_table.description') }} </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                      <td>bcookie</td>
                      <td>{{ $t('cookie-consent.cookies_table.third_party') }}</td>
                      <td>1 {{ $t('cookie-consent.cookies_table.year') }}</td>
                      <td>{{ $t('cookie-consent.cookies_table.bcookie_description') }}</td>
                    </tr>
                    <tr>
                      <td style="word-break: break-all;">li_gc</td>
                      <td>{{ $t('cookie-consent.cookies_table.third_party') }}</td>
                      <td>6 {{ $t('cookie-consent.cookies_table.months') }}</td>
                      <td>{{ $t('cookie-consent.cookies_table.li_gc_description') }}</td>
                    </tr>
                    <tr>
                      <td>lidc</td>
                      <td>{{ $t('cookie-consent.cookies_table.third_party') }}</td>
                      <td>24 {{ $t('cookie-consent.cookies_table.hours') }}</td>
                      <td>{{ $t('cookie-consent.cookies_table.lidc_description') }}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </b-collapse>
            <br>
            <h4>{{ $t('cookie-consent.video') }}</h4>
            <p>
              {{ $t('cookie-consent.vimeo_video_description') }}<br>
              <span v-html="$t('cookie-consent.vimeo_video_description_2')"></span>
            </p>
            <h4>{{ $t('cookie-consent.how_control_cookies.title') }}</h4>
            <p>
              {{ $t('cookie-consent.how_control_cookies.1') }}<br>
              {{ $t('cookie-consent.how_control_cookies.2') }}<br>
              {{ $t('cookie-consent.how_control_cookies.3') }}<br>
              <a href="https://support.google.com/chrome/answer/95647?hl=en-GB&co=GENIE.Platform%3DDesktop">Google Chrome</a><br>
              <a href="https://support.apple.com/en-us/105082">Safari (iPhone)</a><br>
              <a href="https://help.apple.com/safari/mac/8.0/en.lproj/sfri11471.html">Safari (Mac)</a><br>
              <a href="https://support.mozilla.org/en-US/products/firefox/protect-your-privacy/cookies">Mozilla Firefox</a><br>
              <a href="https://www.samsung.com/uk/support/mobile-devices/using-the-samsung-internet-app/">Samsung Internet (Mobile)</a><br>
              <a href="https://www.microsoft.com/en-us/edge/learning-center/how-to-manage-and-clear-your-cache-and-cookies?form=MA13I2">Microsoft Edge</a><br>
              <a href="https://blogs.opera.com/news/2015/08/how-to-manage-cookies-in-opera/">Opera</a><br>
              {{ $t('cookie-consent.how_control_cookies.4') }}<br>
            </p>
            <h4>{{ $t('cookie-consent.contact_us') }}</h4>
            <p>
              {{ $t('cookie-consent.to_report_violation') }}<a href="mailto:info@147training.com">info@147training.com</a><br>
              {{ $t('cookie-consent.last_review') }}: 19 {{ $t('cookie-consent.august') }}, 2024<br>
            </p>
          </div>
        </div>
        <div style="padding: 0 1.5rem 1.5rem 1.5rem;">
          <hr style="margin-top: 0">
          <button class="button is-primary" @click="savePreferences">
            {{ $t('cookie-consent.save_preferences') }}
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<style scoped>
  .cookie-consent{
    font-family: Calibri, sans-serif !important;
  }
  .cookie-consent p {
    font-size: 14px !important;
  }
  .cookie-consent .content {
    font-size: 14px !important;
  }
  .show_details {
    font-size: 14px;
    font-weight: normal;
    cursor: pointer;
  }
</style>

<script>

import JsCookie from 'js-cookie';

export default {
  name: 'CookieConsent',
  props: {
    do_not_open_by_default: { type: Boolean, default: false }
  },
  data() {
    return {
      is_cookie_consent_modal_active: !JsCookie.get('necessary_cookies_consent') && !this.do_not_open_by_default,
      is_cookie_preference_modal_active: false,
      necessary_cookies_consent: true,
      statistics_cookies_consent: !!JsCookie.get('statistics_cookies_consent'),
      social_cookies_consent: !!JsCookie.get('social_cookies_consent'),
      show_necessary_cookies_details: false,
      show_statistics_cookies_details: false,
      show_social_cookies_details: false
    };
  },
  mounted() {
    VueEventHub.$on('open-cookie-consent-modal', this.openCookieConsentModal);
    VueEventHub.$on('open-cookie-preference-modal', this.openCookiePreferenceModal);
  },
  methods: {
    openCookieConsentModal() {
      this.is_cookie_consent_modal_active = true;
    },
    closeCookieConsentModal() {
      this.is_cookie_consent_modal_active = false;
    },
    openCookiePreferenceModal() {
      this.is_cookie_preference_modal_active = true;
    },
    closeCookiePreferenceModal() {
      this.is_cookie_preference_modal_active = false;
    },
    acceptAll() {
      JsCookie.set('necessary_cookies_consent', 1, { expires: 365 });
      JsCookie.set('social_cookies_consent', 1, { expires: 365 });
      JsCookie.set('statistics_cookies_consent', 1, { expires: 365 });
      this.loadGoogleAnalytics();
      this.closeCookieConsentModal();
    },
    acceptOnlyNecessary() {
      JsCookie.set('necessary_cookies_consent', 1, { expires: 365 });
      this.statistics_cookies_consent = false;
      if (JsCookie.get('statistics_cookies_consent')) {
        JsCookie.remove('statistics_cookies_consent');
        this.deleteGoogleAnalyticsCookies();
      }
      this.social_cookies_consent = false;
      if (JsCookie.get('social_cookies_consent')) {
        JsCookie.remove('social_cookies_consent');
        this.deleteLinkedinCookies();
      }

      this.closeCookieConsentModal();
    },
    savePreferences() {
      JsCookie.set('necessary_cookies_consent', 1, { expires: 365 });
      if (this.statistics_cookies_consent) {
        JsCookie.set('statistics_cookies_consent', 1, { expires: 365 });
        this.loadGoogleAnalytics();
      } else {
        if (JsCookie.get('statistics_cookies_consent')) {
          JsCookie.remove('statistics_cookies_consent');
        }
        this.deleteGoogleAnalyticsCookies();
      }
      if (this.social_cookies_consent) {
        JsCookie.set('social_cookies_consent', 1, { expires: 365 });
      } else {
        if (JsCookie.get('social_cookies_consent')) {
          JsCookie.remove('social_cookies_consent');
        }
        this.deleteLinkedinCookies();
      }
      this.closeCookiePreferenceModal();
    },
    loadGoogleAnalytics() {
      //check if loaded
      if (typeof gtag !== 'function') {
        // eslint-disable-next-line no-undef
        const tag_id = GOOGLE_ANALYTICS_TAG;
        const script_element = document.createElement('script');
        script_element.setAttribute('src', 'https://www.googletagmanager.com/gtag/js?id=' + tag_id);
        script_element.async = true;
        document.head.appendChild(script_element);

        window.dataLayer = window.dataLayer || [];
        window.gtag = function () {
          window.dataLayer.push(arguments);
        };

        window.gtag('js', new Date());
        window.gtag('config', tag_id);
      }
    },
    deleteGoogleAnalyticsCookies() {
      const cookie_names = Object.keys(JsCookie.get());
      const ga_cookie_names = [];
      if (cookie_names) {
        cookie_names.forEach(value => {
          if (value.startsWith('_ga')) {
            ga_cookie_names.push(value);
          }
          if (value.startsWith('_gid')) {
            ga_cookie_names.push(value);
          }
          if (value.startsWith('_gat_')) {
            ga_cookie_names.push(value);
          }
        });
      }
      if (ga_cookie_names.length) {
        ga_cookie_names.forEach(value => {
          JsCookie.remove(value, { path: '/', domain: '.' + window.location.hostname });
        });
      }
    },
    deleteLinkedinCookies() {
      const cookie_names = Object.keys(JsCookie.get());
      const linkedin_cookie_names = [];
      if (cookie_names) {
        cookie_names.forEach(value => {
          if (value === 'bcookie') {
            linkedin_cookie_names.push(value);
          }
          if (value === 'li_gc') {
            linkedin_cookie_names.push(value);
          }
          if (value === 'lidc') {
            linkedin_cookie_names.push(value);
          }
        });
      }
      if (linkedin_cookie_names.length) {
        linkedin_cookie_names.forEach(value => {
          JsCookie.remove(value, { path: '/', domain: '.' + window.location.hostname });
        });
      }
    }
  }
};
</script>
